<div
  class="input radio-list"
  [ngClass]="'radio-list--' + radioListStyle"
  role="radiogroup"
  [attr.aria-labelledby]="name"
>
  @if (label) {
    <div [attr.id]="name" class="radio-list__group-label">{{ label }}</div>
  }
  <div class="radio-list__items">
    @for (item of radioItems$() | async; track item.value) {
      <ftr-radio
        class="radio-list__item"
        [name]="name"
        [label]="item.key"
        [value]="item.value"
        [summary]="item.summary"
        [summaryTemplate]="item.summaryTemplate || null"
        [control]="control"
      />
    }
  </div>

  <span
    class="input__validation"
    ftrValidationErrorHint
    [label]="validationLabel"
    [ngFormControl]="control"
    [controlTouched]="control.touched"
    [submitAttempted]="submitAttempted"
  ></span>
</div>
